
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5.857a11.143 11.143 0 00-9.274 17.314l-1.87 4.972 6.258-1.132A11.142 11.142 0 1012.5.857v0z","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.5 12.857a.857.857 0 100-1.714.857.857 0 000 1.714zM12.071 12.857a.857.857 0 100-1.714.857.857 0 000 1.714zM17.643 12.857a.857.857 0 100-1.714.857.857 0 000 1.714z","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    